module.exports = __webpack_public_path__ + "static/media/loading2.1eb890f1.gif";